// import React from 'react';
// import styled from 'styled-components';

// const TermsContainer = styled.div`
//   max-width: 800px;
//   margin: 50px auto;
//   padding: 20px;
//   font-family: Arial, sans-serif;
//   line-height: 1.6;
//   color: #333;

//   h1 {
//     text-align: center;
//     color: #007BFF;
//   }

//   h2 {
//     color: #0056b3;
//     margin-top: 20px;
//   }

//   p {
//     margin-bottom: 15px;
//   }

//   ul {
//     margin: 15px 0;
//     padding-left: 20px;
//   }

//   @media (max-width: 768px) {
//     padding: 15px;
//   }
// `;

// const TermsAndConditions = () => {
//   return (
//     <TermsContainer>
//       <h1>Terms and Conditions</h1>
//       <p>Welcome to GoSafari. Please read these Terms and Conditions carefully before using our ride aggregator platform. By accessing or using the app, you agree to be bound by these Terms.</p>

//       <h2>1. Definitions</h2>
//       <p><strong>App:</strong> GoSafari, a ride aggregator platform connecting drivers and riders.</p>
//       <p><strong>User:</strong> Any individual who uses the app to request rides.</p>

//       <h2>2. Eligibility</h2>
//       <p>Users and Drivers must be at least 18 years old. Drivers must have valid credentials as per Nepali laws.</p>

//       <h2>3. Driver Subscription Model</h2>
//       <p>Drivers are required to purchase a subscription plan to access and accept ride requests.</p>

//       <h2>4. Pricing and Payment</h2>
//       <p>Ride fares are negotiated directly between Users and Drivers via the app.</p>

//       <h2>5. User and Driver Conduct</h2>
//       <p>Respectful behavior is expected from both Users and Drivers.</p>

//       <h2>6. Cancellation Policy</h2>
//       <p>Both Users and Drivers can cancel a ride before pickup.</p>

//       <h2>7. Liability and Disclaimers</h2>
//       <p>GoSafari acts solely as an intermediary between Users and Drivers.</p>

//       <h2>8. Data Privacy</h2>
//       <p>Personal data will be collected and processed in compliance with Nepal's Privacy Act 2018.</p>

//       <h2>9. Prohibited Activities</h2>
//       <p>Misrepresentation or offering illegal services is strictly prohibited.</p>

//       <h2>10. Suspension and Termination</h2>
//       <p>Accounts violating these terms may be suspended or terminated.</p>

//       <h2>11. Intellectual Property</h2>
//       <p>All content and software belong to GoSafari.</p>

//       <h2>12. Amendments</h2>
//       <p>GoSafari reserves the right to update these terms.</p>

//       <h2>13. Governing Law</h2>
//       <p>These Terms are governed by the laws of Nepal.</p>

//       <h2>14. Contact Information</h2>
//       <p>For concerns, contact us at Customer Support.</p>
//     </TermsContainer>
//   );
// };

// export default TermsAndConditions;


import React from 'react';
import '../../assets/css/TermOfCondition.css';

const TermsAndConditions = () => {
    return (
        <div className="terms-container">
            <h1>Terms and Conditions</h1>
            <p><strong>Welcome to GoSafari.</strong> Please read these Terms and Conditions ("Terms") carefully before using our ride aggregator platform. You agree to be bound by these Terms by accessing or using the app. If you disagree, please do not use the app.</p>
            
            <h2>1. Definitions</h2>
            <p><strong>App:</strong> GoSafari, a ride aggregator platform connecting drivers and riders.</p>
            <p><strong>User:</strong> Any individual who uses the app to request rides.</p>
            <p><strong>Driver:</strong> Individuals offering transportation services through the app under a subscription model.</p>
            <p><strong>Services:</strong> Ride-booking and related services are offered through the app.</p>

            <h2>2. Eligibility</h2>
            <p>Users and Drivers must be at least <strong>18 years old.</strong></p>
            <p>Drivers must have a valid driver’s license, vehicle registration, and insurance per Nepali laws.</p>
            <p>Users must provide accurate and complete registration details.</p>

            <h2>3. Driver Subscription Model</h2>
            <p>Drivers are required to purchase a subscription plan to access and accept ride requests.</p>
            <p>Subscription fees are <strong>non-refundable</strong> and are subject to change with prior notice.</p>
            <p>Subscription payments must comply with applicable tax laws in Nepal.</p>

            <h2>4. Pricing and Payment</h2>
            <p>Ride fares are negotiated directly between Users and Drivers via the app.</p>
            <p>Users must confirm the agreed price before booking a ride.</p>
            <p>Payments can be made via cash, digital wallets, or any in-app payment method as per mutual agreement.</p>
            <p>The app is not responsible for disputes regarding payment amounts agreed upon outside the app.</p>

            <h2>5. User and Driver Conduct</h2>
            <p>Users and Drivers must behave respectfully and responsibly during interactions.</p>
            <p>Illegal activities, harassment, or misuse of the platform will result in account suspension or termination.</p>
            <p>Drivers must adhere to traffic rules and vehicle safety standards under Nepali law.</p>

            <h2>6. Cancellation Policy</h2>
            <p>Both Users and Drivers can cancel a ride before pickup.</p>
            <p>Frequent cancellations may result in temporary or permanent suspension of the account.</p>

            <h2>7. Liability and Disclaimers</h2>
            <p>GoSafari acts solely as an intermediary between Users and Drivers and does not provide transportation services.</p>
            <p>The app is not liable for accidents, injuries, damages, or losses that occurred during rides.</p>
            <p>Drivers are responsible for their vehicles and compliance with traffic and safety laws.
            </p>

            <h2>8. Data Privacy</h2>
            <p>Personal data will be collected, stored, and processed in compliance with Nepal's Privacy Act 2018 and Google Play Store policies.</p>
            <p>Data will only be used for service improvement and legal compliance.</p>

            <h2>9. Prohibited Activities</h2>
            <p>Misrepresentation of identity or vehicle details.</p>
            <p>Use of unauthorized or stolen payment methods.</p>
            <p>Offering or accepting illegal services.
            </p>

            <h2>10. Suspension and Termination</h2>
            <p>We may suspend or terminate accounts that violate these Terms, Nepali law, or Google Play policies without prior notice.</p>

            <h2>11. Intellectual Property</h2>
            <p>All content, trademarks, and software within the app belong to GoSafari and may not be used without permission.</p>

            <h2>12. Amendments</h2>
            <p>GoSafari reserves the right to update these Terms. Continued use of the app after updates constitutes acceptance of the revised Terms.</p>

            <h2>13. Governing Law</h2>
            <p>These Terms are governed by the laws of Nepal.</p>
            <p>Any disputes shall be resolved under Nepali legal procedures</p>

            <h2>14. Contact Information</h2>
            <p>For questions or concerns, contact us at Customer Support.</p>

            <p style={{textAlign:"center" }}><strong>By using GoSafari, you agree to these Terms and Conditions.</strong></p>
        </div>
    );
}

export default TermsAndConditions;

